import { Component, Input } from "@angular/core";

@Component({
  selector: "app-streak-card",
  template: `
    <div class="streak-card">
      <div class="icon-container">
        <img [src]="messageData.iconUrl" alt="" />
      </div>
      <div class="streak-content">
        <div class="heading">{{ messageData.heading }}</div>
        <p [innerHTML]="messageData.message"></p>
      </div>
    </div>
  `,
  styles: [
    `
      .streak-card {
        display: flex;
        background: #d1ffd3 0% 0% no-repeat padding-box;
        border-radius: 10px;
        padding: 10px 20px;
        gap: 20px;
        align-items: center;
      }
      .icon-container {
        width: 110px;
        height: 110px;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #0000001a;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .streak-content {
        flex: 1;
        padding: 8px 0px;
      }

      .heading {
        margin-bottom: 15px;
        font-size: 26px;
        font-weight: 500;
        color: #000;
      }
      p {
        font-size: 17px;
      }
    `,
  ],
})
export class StreakCardComponent {
  @Input() messageData = {
    iconUrl: "",
    heading: "",
    message: "",
  };
}
